module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_3.7af50f8f.png";